import './overview.scss';
import { autoinject, bindable } from 'aurelia-framework';
import { MapFeatureOnClickArgs } from 'views/mooring/mooring-map/renderOptions';
import { MooringOfferDocumentsHandler } from 'services/attachments/mooring-offer-documents-handler';
import { AttachmentHandlerFactory } from 'services/attachments/attachment-handler-factory';
import { MooringAttachmentType } from 'models/mooring/MooringAttachments';
import { MooringDocumentsHandler } from 'services/attachments/mooring-documents-handler';

@autoinject()
export class Overview {
  @bindable
  offerId: number;

  @bindable
  mooringId: number;

  protected analysisAttachmentHandler: MooringDocumentsHandler;
  protected documentHandler: MooringOfferDocumentsHandler;

  protected onFeatureClick(args: MapFeatureOnClickArgs) {
    //
  }

  constructor(private attachmentHandlerFactory: AttachmentHandlerFactory) {}

  private attached() {

    this.analysisAttachmentHandler = this.attachmentHandlerFactory.mooringAttachmentHandler({
      mooringId: this.mooringId,
      attachmentType: MooringAttachmentType.Analysis,
    });

    this.documentHandler = this.attachmentHandlerFactory.mooringOfferDocumentsHandler({
      mooringOfferId: this.offerId,
    });
  }
}
